import { theme } from 'antd';
import { DeletedFilled, DeviceGroupsIcon, EnableIcon, RevokeAccessIcon } from 'assets/images/svg';
import { useManagePermittedRoles } from 'library/hooks';
import React, { useState } from 'react';
import {
	DeleteDeviceGroupsModal,
	GrantPermissionsToGroupModal,
	ManageDevicesToGroupModal
} from 'zComponents/molecules';
import { Button, Divider, Dropdown, Flex, Tooltip } from 'zui/Antd';

const ManageDeviceGroupDropdown = ({ groupIDs = [], isTransparent = false }) => {
	// ✅ Hooks
	const {
		token: { colorBgContainer, boxShadow, borderRadiusLG, paddingSM, colorPrimaryText, fontWeightStrong }
	} = theme.useToken();

	// ✅ Permissions
	const canManagePermissions = useManagePermittedRoles('aCPermissionManagement');
	const canUpdateGroup = useManagePermittedRoles('updateGroup');
	const canRevokeGroupAccess = useManagePermittedRoles('revokeGroupAccess');
	const canDisableGroup = useManagePermittedRoles('disableGroup');
	const canDeleteGroup = useManagePermittedRoles('deleteGroup');
	const permissionDeniedMessage = "You don't have permission to perform this action.";

	// ✅ Get the first groupID
	const groupID = groupIDs[0];

	// ✅ Local States
	const [openDropdown, setOpenDropdown] = useState(false);

	const items = [
		{
			key: 'managePermissions',
			label: (
				<GrantPermissionsToGroupModal groupID={groupID}>
					<Button
						type='text'
						icon={<EnableIcon width={16} height={16} color='currentColor' />}
						block
						disabled={!canManagePermissions}
						style={{
							justifyContent: 'flex-start',
							fontWeight: fontWeightStrong
						}}
					>
						Manage Permissions
					</Button>
				</GrantPermissionsToGroupModal>
			)
		},
		{
			key: 'manageDevices',
			label: (
				<ManageDevicesToGroupModal groupID={groupID}>
					<Button
						type='text'
						icon={<DeviceGroupsIcon color='currentColor' />}
						block
						disabled={!canUpdateGroup}
						style={{
							justifyContent: 'flex-start',
							fontWeight: fontWeightStrong
						}}
					>
						Manage Devices
					</Button>
				</ManageDevicesToGroupModal>
			)
		},
		{
			key: 'divider',
			label: <Divider style={{ margin: 0 }} />
		},
		{
			key: 'revokeAccess',
			label: (
				<Tooltip
					title={!canRevokeGroupAccess ? permissionDeniedMessage : 'Currently working on it'}
					placement='top'
				>
					<Button
						type='text'
						icon={<RevokeAccessIcon color='currentColor' />}
						block
						style={{
							justifyContent: 'flex-start',
							fontWeight: fontWeightStrong
						}}
						disabled={!canRevokeGroupAccess || true}
					>
						Revoke All Access
					</Button>
				</Tooltip>
			)
		},
		{
			key: 'disableGroup',
			label: (
				<Tooltip title={!canDisableGroup ? permissionDeniedMessage : 'Currently working on it'} placement='top'>
					<Button
						type='text'
						icon={<EnableIcon width={16} height={16} color='currentColor' />}
						block
						style={{
							justifyContent: 'flex-start',
							fontWeight: fontWeightStrong
						}}
						disabled={!canDisableGroup || true}
					>
						Disable Device Group
					</Button>
				</Tooltip>
			)
		},
		{
			key: 'deleteGroup',
			label: (
				<DeleteDeviceGroupsModal groupIDs={groupIDs}>
					<Button
						type='text'
						danger
						icon={<DeletedFilled color='currentColor' width={16} height={16} />}
						block
						disabled={!canDeleteGroup}
						style={{
							justifyContent: 'flex-start',
							fontWeight: fontWeightStrong
						}}
					>
						Delete Device Group
					</Button>
				</DeleteDeviceGroupsModal>
			)
		}
	];

	return (
		<Dropdown
			trigger={['click']}
			placement='bottomLeft'
			open={openDropdown}
			onOpenChange={(visible) => setOpenDropdown(visible)}
			dropdownRender={() => (
				<Flex
					style={{
						backgroundColor: colorBgContainer,
						borderRadius: borderRadiusLG,
						width: 240,
						boxShadow: boxShadow,
						padding: paddingSM
					}}
					vertical
					gap={paddingSM}
				>
					{items.map((item) => (
						<div key={item.key} onClick={() => setOpenDropdown(false)}>
							{item.label}
						</div>
					))}
				</Flex>
			)}
		>
			<Button type={isTransparent ? 'text' : 'primary'} style={{ color: isTransparent && colorPrimaryText }}>
				{isTransparent ? 'View' : 'Manage'} Device Group
			</Button>
		</Dropdown>
	);
};

export default ManageDeviceGroupDropdown;
